<template>
  <section
    :id="`${cms.scroll_id}`"
    v-editable="cms"
    :class="[name, spacing]"
    :style="mainCssVars"
  >
    <grid
      :class="['grid--container', `${name}__grid`, `${name}__top`]"
      :layout="[
        {
          size: 1,
          columns: 'repeat(24, 1fr)',
          rows: 'minmax(73px, auto) 1fr',
          gap: '10px',
        },
        {
          size: 2,
          columns: 'repeat(24, 1fr)',
          gap: '40px',
        },
      ]"
    >
      <grid-item
        :html-tag="`nav`"
        :class="[`${name}__grid-item`, `${name}__footnotes footnotes_link`]"
        :layout="[{ size: 1, x: 1, width: 24 }]"
      >
        <ul :class="[`${name}__footnote-list footnote_link_container`]">
          <li v-for="(item, index) in cms.footnotes" :key="index">
            <component
              :is="item.component"
              v-editable="item"
              :cms="item"
              :class="`${name}__footnote-item`"
            />
          </li>
        </ul>
        <ul :class="[`${name}__social-icons social_icon_container`]">
          <li>
            <a
              href="https://www.instagram.com/tribalwwlondon"
              target="_blank"
              aria-label="Tribal Instagram Page"
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="32"
                height="33"
                viewBox="0 0 32 33"
              >
                <path
                  d="M32 16.1016C32 24.9383 24.8367 32.1016 16 32.1016C7.16328 32.1016 0 24.9383 0 16.1016C0 7.26484 7.16328 0.101562 16 0.101562C24.8367 0.101562 32 7.26484 32 16.1016Z"
                  fill="currentColor"
                />
                <path
                  d="M20.3414 7.70898H11.6593C9.42217 7.70898 7.60779 9.52336 7.60779 11.7605V20.4426C7.60779 22.6798 9.42217 24.4942 11.6593 24.4942H20.3414C22.5786 24.4942 24.393 22.6798 24.393 20.4426V11.7605C24.393 9.52336 22.5786 7.70898 20.3414 7.70898ZM22.9458 20.1527C22.9458 21.7505 21.6493 23.047 20.0515 23.047H11.9484C10.3507 23.047 9.05414 21.7505 9.05414 20.1527V12.0496C9.05414 10.4519 10.3507 9.15533 11.9484 9.15533H20.0515C21.6493 9.15533 22.9458 10.4519 22.9458 12.0496V20.1527Z"
                  fill="white"
                />
                <path
                  d="M16.0089 11.7598C13.6131 11.7598 11.6682 13.7046 11.6682 16.1004C11.6682 18.4962 13.6131 20.4411 16.0089 20.4411C18.4047 20.4411 20.3495 18.4962 20.3495 16.1004C20.3495 13.7046 18.4047 11.7598 16.0089 11.7598ZM16.0089 18.9947C14.4143 18.9947 13.1146 17.6949 13.1146 16.1004C13.1146 14.5059 14.4143 13.2061 16.0089 13.2061C17.6034 13.2061 18.9032 14.5059 18.9032 16.1004C18.9032 17.6949 17.6034 18.9947 16.0089 18.9947Z"
                  fill="white"
                />
                <path
                  d="M20.6394 12.3398C20.161 12.3398 19.7712 11.95 19.7712 11.4716C19.7712 10.9933 20.161 10.6035 20.6394 10.6035C21.1177 10.6035 21.5075 10.9933 21.5075 11.4716C21.5075 11.95 21.1177 12.3398 20.6394 12.3398Z"
                  fill="white"
                />
              </svg>
            </a>
          </li>
          <li>
            <a
              href="https://www.linkedin.com/company/tribal-worldwide-london/"
              target="_blank"
              aria-label="Tribal LinkedIn Page"
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="32"
                height="33"
                viewBox="0 0 32 33"
              >
                <path
                  d="M32 16.1016C32 24.9383 24.8367 32.1016 16 32.1016C7.16328 32.1016 0 24.9383 0 16.1016C0 7.26484 7.16328 0.101562 16 0.101562C24.8367 0.101562 32 7.26484 32 16.1016Z"
                  fill="currentColor"
                />
                <path
                  d="M10.3339 11.8247C11.472 11.8247 12.3947 10.9021 12.3947 9.76392C12.3947 8.62577 11.472 7.70312 10.3339 7.70312C9.19572 7.70312 8.27307 8.62577 8.27307 9.76392C8.27307 10.9021 9.19572 11.8247 10.3339 11.8247Z"
                  fill="white"
                />
                <path
                  d="M11.8971 13.1973H8.77003C8.68508 13.1973 8.61621 13.2661 8.61621 13.3511V23.3467C8.61621 23.4316 8.68508 23.5005 8.77003 23.5005H11.8971C11.982 23.5005 12.0509 23.4316 12.0509 23.3467V13.3511C12.0509 13.2661 11.982 13.1973 11.8971 13.1973Z"
                  fill="white"
                />
                <path
                  d="M23.7287 16.9771V22.8156C23.7287 23.1933 23.4195 23.5025 23.0418 23.5025H20.981C20.6033 23.5025 20.2941 23.1933 20.2941 22.8156V18.0071C20.2941 17.0592 19.525 16.2901 18.5771 16.2901C17.6293 16.2901 16.8602 17.0592 16.8602 18.0071V22.8156C16.8602 23.1933 16.551 23.5025 16.1733 23.5025H14.1125C13.7348 23.5025 13.4255 23.1933 13.4255 22.8156V13.8855C13.4255 13.5078 13.7348 13.1985 14.1125 13.1985H16.1733C16.551 13.1985 16.8602 13.5078 16.8602 13.8855V14.3252C17.5471 13.4353 18.6842 12.8555 19.951 12.8555C21.8467 12.8555 23.7287 14.2293 23.7287 16.9771Z"
                  fill="white"
                />
              </svg>
            </a>
          </li>
        </ul>
      </grid-item>

      <grid-item
        :class="[`${name}__grid-item`, `${name}__general`, 'second-container']"
        :layout="[{ size: 24, x: 1 }]"
      >
        <div class="links_img_container">
          <div class="company-container cyber_img">
            <img
              src="~/assets/svgs/cyber-essentials.svg"
              alt="cyber essentials"
            />
          </div>
          <div class="company-container">
            <div class="company-details">
              <div>{{ cms.general[0].heading }}</div>
              <!-- eslint-disable-next-line vue/no-v-html -->
              <div v-html="cms.general[0].copy"></div>
            </div>
            <div class="company-details">
              <div>{{ cms.general[1].heading }}</div>
              <!-- eslint-disable-next-line vue/no-v-html -->
              <div v-html="cms.general[1].copy"></div>
            </div>
          </div>
        </div>
        <ul :class="[`${name}__social-list a-copyright`]">
          <li v-for="(item, index) in cms.social" :key="index">
            <component
              :is="item.component"
              v-editable="item"
              :cms="item"
              :class="`${name}__social-item`"
            />
          </li>
        </ul>
      </grid-item>
    </grid>
  </section>
</template>

<script>
import data from '~/components/organisms/o-site-footer/o-site-footer-v2.data'
import Colors from '~/mixins/colors'
import ASvgLogo from '~/components/atoms/a-svgs/a-svg-logo'
export default {
  components: { ASvgLogo },
  mixins: [Colors],
  props: {
    cms: {
      type: Object,
      default() {
        const config = {}
        return process.env.NODE_ENV === 'development'
          ? { ...data, ...config }
          : config
      },
    },
  },

  data() {
    return {
      name: 'o-site-footer-v2',
    }
  },

  computed: {
    spacing() {
      return this.cms.spacing
    },
    mainCssVars() {
      return {
        padding: '31px',
        '--bg-color': this.setColor(
          (this.cms.color_background || {}).color || 'white',
          this.cms.color_gradient
        ),
        '--text-color': this.setColor(
          (this.cms.color_text || {}).color || 'black'
        ),
        '--hover-color': this.setColor(
          (this.cms.color_hover || {}).color || '#C33CA8'
        ),
        '--disabled-color': this.setColor(
          (this.cms.color_disabled || {}).color || '#888b8d'
        ),
      }
    },
  },
}
</script>

<style lang="scss" scoped>
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.2s ease;
}
.fade-enter,
.fade-leave-to {
  opacity: 0;
}
.grid--container {
  border-top: 1px solid black;
  padding-top: 40px;
  padding-left: 0;
  padding-right: 0;
}

@media (max-width: 767px) {
  .grid--container {
    display: flex;
    flex-direction: column;
    gap: 40px;
  }
}

.second-container > .links_img_container {
  display: flex;
  flex-direction: column;
  gap: 1rem;
}

.second-container {
  display: flex;
  flex-direction: column;
  gap: 2rem;
}

@media (min-width: 768px) {
  .second-container > .links_img_container {
    display: flex;
    flex-direction: row;
    justify-content: flex-start;
    align-items: flex-start;
    gap: 2rem;
  }

  .a-copyright {
    display: flex;
    flex-direction: column;
    align-items: flex-end;
  }
}

@media (max-width: 767px) {
  .second-container > .links_img_container {
    display: flex;
    flex-direction: column-reverse;
    gap: 40px;
  }
}

.company-container {
  display: flex;
  flex-direction: row;
  gap: 16px;
}

@media (max-width: 767px) {
  .company-container {
    display: flex;
    flex-direction: row;
    align-items: center;
    gap: 2rem;
  }
}

@media (min-width: 768px) {
  .company-container {
    display: flex;
    flex-direction: row;
    gap: 4rem;
  }
}

.company-details {
  font-family: 'NeueHaasGroteskText', Helvetica, Arial, sans-serif;
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
}

.o-site-footer-v2 {
  transition: background-color 0.2s ease-in-out, color 0.2s ease-in-out,
    border 0.2s ease-in-out;
  background: var(--bg-color);
  border-color: var(--text-color);
  color: var(--text-color);

  ::v-deep a,
  ::v-deep .a-cta {
    color: var(--text-color);
    &:hover,
    &:active {
      color: var(--hover-color);
    }
    &:disabled,
    &.disabled {
      color: var(--disabled-color);
    }
  }

  &__top {
    align-content: center;

    ::v-deep .a-heading {
      @include font-family($headings-font-family, 600);
      @include font-size(14, 24px);

      margin: 0;
      letter-spacing: 1px;
    }

    ::v-deep .a-copy p {
      @include font-size(14, 24px);

      margin: 0 0 30px;
    }

    ::v-deep .a-copy:last-child p {
      margin-bottom: 0;
    }
  }

  &__footnotes {
    display: flex;
    justify-content: space-between;
  }

  &__social-icons {
    list-style-type: none;
    display: flex;
    gap: 16px;

    li {
      cursor: pointer;
    }

    li:hover svg {
      color: #ff3476;
    }
  }

  &__bottom {
    padding-block: 60px;
    align-content: center;

    ::v-deep .a-copy p,
    ::v-deep .a-link-v2 {
      @include font-size(14, 24px);

      margin: 0;
    }
  }

  &__general {
    margin-bottom: 50px;

    ::v-deep .a-link-v2 {
      @include font-size(14, 24px);
    }
  }

  &__contacts {
    margin-bottom: 50px;
  }

  &__social-list {
    font-size: 12px !important;
    font-style: normal;
    font-weight: 700;
    line-height: 125%; /* 15px */
    font-family: 'NeueHaasGroteskText', Helvetica, Arial, sans-serif;
  }

  &__social-list,
  &__general-list {
    padding: 0;
    list-style: none;

    li {
      @include font-size(14, 24px);

      margin-bottom: 20px;

      &:last-child {
        margin-bottom: 0;
      }
    }
  }

  &__footnote-list {
    padding: 0;
    list-style: none;

    li {
      padding-right: 20px;

      &:last-child {
        padding-bottom: 0;
      }
    }
  }
}

@media (max-width: 767px) {
  .footnotes_link {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    gap: 40px;
  }

  .footnote_link_container {
    display: flex;
    flex-direction: column;
    gap: 20px;
  }

  .social_icon_container {
    display: flex;
    padding: 0;
    margin: 0;
    flex-direction: row;
    align-items: flex-start;
  }
}

@include media-breakpoint-up(md) {
  .o-site-footer-v2 {
    &__bottom {
      padding-block: 40px;
    }

    &__footnote-list {
      li {
        float: left;
      }
    }
  }
}
</style>
